import { Component, OnInit } from "@angular/core";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { TranslateService } from "@ngstack/translate";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { CustomValidators } from "src/app/shared/customValidators";
import { IChangePass } from "src/app/interfaces/changePass";
import { SoundEnum } from "src/app/enums/sound.enum";
import { ErrorsService } from "src/app/services/common/errors.service";
import { AccountService } from "src/app/services/http/business/account/account.service";
import { Title } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.css"],
  providers: [ErrorsService]
})
export class ChangePasswordComponent implements OnInit {
  resetPassForm: FormGroup;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private titleService: Title,
    private accountService: AccountService
  ) {}

  ngOnInit() {
    this.titleService.setTitle(environment.siteTitle);
    this.resetPassForm = this.fb.group(
      {
        OldPassword: [null, Validators.compose([Validators.required])],
        Password: [
          null,
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(30),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,30}$/
            )
          ])
        ],
        RePassword: [null, Validators.compose([Validators.required])]
      },
      { validator: CustomValidators.passwordMatchValidator }
    );
  }

  submitForm(form: IChangePass) {
    this.errors = new Array();
    this.accountService.resetPass(form).subscribe(
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.changePass"),
          "OK",
          5000,
          SoundEnum.beep
        );
      },
      error => {
        // this.errObject = this.errorService.getError(error);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(error);
        this.errorList = this.errorService.getErrorList(error.error);
      }
    );
  }
}
